import { ButtonBase, Paper } from '@mui/material';
import { useDialog } from '@prismamedia/one-components';
import { FC, useMemo } from 'react';
import { FullscreenRailroad } from './Railroad/FullscreenRailroad';
import { RailroadIssueFullPage } from './Railroad/RailroadIssueFullPage';
import { RailroadFullPage } from './Railroad/utils';
import { useGetRailRoadPages } from './utils';

export const Railroad: FC<{
  selectedIssue: string;
}> = ({ selectedIssue }) => {
  const { pages } = useGetRailRoadPages(selectedIssue);
  const { openDialog } = useDialog();

  const fullPages = useMemo(() => {
    return (
      pages?.reduce<RailroadFullPage[]>((prev, page) => {
        const lastFullPage = prev[prev.length - 1];
        if (!lastFullPage || lastFullPage.length === 2 || prev.length === 1) {
          return [...prev, [page]];
        }

        // eslint-disable-next-line immutable/no-mutation
        prev[prev.length - 1] = [lastFullPage[0], page];
        return prev;
      }, []) || []
    );
  }, [pages]);

  if (!fullPages?.length) {
    return null;
  }

  return (
    <Paper
      sx={{
        display: 'flex',
        overflowX: 'auto',
        p: 2,
        m: 2,
        mb: 0,
        width: '100%',
      }}
    >
      {fullPages?.map((_, pageIndex) => (
        <ButtonBase
          key={pageIndex}
          sx={{ mr: 2 }}
          onClick={() => {
            openDialog(
              <FullscreenRailroad
                pages={fullPages}
                startingIndex={pageIndex}
              />,
              {
                fullScreen: true,
              },
            );
          }}
        >
          <RailroadIssueFullPage
            pages={fullPages}
            pageIndex={pageIndex}
            displayOptions={{
              displayBorders: true,
              displayThumbnails: true,
              size: 4,
              miniature: false,
              displayInfos: false,
              displayPageNumber: true,
            }}
            containerSx={{
              width: '20vw',
            }}
          />
        </ButtonBase>
      ))}
    </Paper>
  );
};
